<template>
	<page>
		<module ref="module" :drag="false" gap="10">
			<module-row>
				<module-col size="400" title="看板基础信息">
					<c-form ref="form" vertical unit-width="100%">
						<c-form-item label="看板标题名称" required tip="标题名称不允许重复">
							<c-input type="hidden" name="id"></c-input>
							<c-input name="title" maxlength="12"></c-input>
						</c-form-item>
						<c-form-item ref="layout" label="看板布局" name="layout" required tip="右键模块可修改布局，按住并拖动模块可调整位置">
							<template #handle>
								<c-dropdown>
									<c-link color="main" style="line-height: 26px;">布局模板</c-link>

									<template #menu>
										<c-menu-list>
											<c-menu-item v-for="(item, i) in layoutTemplet" :key="i" @click="templetHandle(item)">{{item.name}}</c-menu-item>
										</c-menu-list>
									</template>
								</c-dropdown>
							</template>
							<div class="layout flex-column" :style="{'cursor': sortModuleConfig ? 'move' : ''}">
								<div v-for="(row, i) in layout" :key="i" class="layout-row flex flex-grow">
									<c-right-menu v-for="(col, j) in row" :key="j" class="flex-grow">
										<div
											:ref="`${i}-${j}`"
											class="layout-col flex-center"
											:class="{
												'z-crt': col == currentModule && (!sortModuleConfig || !sortModuleConfig.module),
												'z-empty': !moduleConfig[col.module_id],
												'z-hl': sortModuleConfig && sortModuleConfig.target == col
											}"
											:style="sortModuleConfig && col == sortModuleConfig.module ? sortModuleConfig.position : ''"
											@click="switchModule(col)"
											@mousedown="sortModule(i, j, col, $event)"
											@mouseup="sortHandle(i, j, col, $event)"
											@mouseenter="sortHandle(i, j, col, $event)"
											@mouseleave="sortHandle(i, j, col, $event)"
											@contextmenu="rightMenuTarget = {row: i, col: j, id: col.module_id, type: col.module_type}"
										>
											<img :src="require(`@/assets/image/digital/${moduleName[col.module_type]}.jpg`)" alt="">
											<span>{{moduleName[col.module_type]}}</span>
										</div>

										<template #menu>
											<c-menu-list>
												<c-menu-group v-for="(group, i) in rightMenu" :key="i">
													<template v-for="(item, j) in group">
														<c-menu-list v-if="item.submenu" :key="j">
															<c-menu-item>{{item.name}}</c-menu-item>
															<template #menu>
																<c-menu-item v-for="(sub, k) in item.submenu" :key="k" @click="rightMenuHandle(sub)">
																	<div class="flex-between-center">
																		<span>{{sub.name}}</span>
																		<c-tooltip position="right" color="white">
																			<template #tip>
																				<p style="margin-bottom: 5px; line-height: 20px; color: #999;">示意图</p>
																				<img :src="require(`@/assets/image/digital/${sub.name}.jpg`)" alt="" style="width: 350px;">
																			</template>
																		</c-tooltip>
																	</div>
																</c-menu-item>
															</template>
														</c-menu-list>
														<c-menu-item v-else :key="j" :color="item.color" @click="rightMenuHandle(item)">{{item.name}}</c-menu-item>
													</template>
												</c-menu-group>
											</c-menu-list>
										</template>
									</c-right-menu>
								</div>
							</div>
						</c-form-item>
						<c-form-item label="菜单名称" required tip="菜单名称不允许重复">
							<c-input name="name" maxlength="8"></c-input>
						</c-form-item>
					</c-form>
				</module-col>
				<module-col class="module-config-box">
					<charts-config v-if="currentModule.module_type == 1" ref="config" :key="currentModule.module_id"></charts-config>
					<quota-config v-else-if="currentModule.module_type == 2" ref="config" :key="currentModule.module_id"></quota-config>
					<list-config v-else-if="currentModule.module_type == 3" ref="config" :key="currentModule.module_id"></list-config>
					<total-config v-else-if="currentModule.module_type == 4" ref="config" :key="currentModule.module_id"></total-config>
					<notice-config v-else-if="currentModule.module_type == 5" ref="config" :key="currentModule.module_id"></notice-config>
					<timeline-config v-else-if="currentModule.module_type == 6" ref="config" :key="currentModule.module_id"></timeline-config>
					<gallery-config v-else-if="currentModule.module_type == 7" ref="config" :key="currentModule.module_id"></gallery-config>
				</module-col>
				<template #button>
					<c-button v-if="auth('b_digital_config')" v-lock="lock('b_digital_config')" size="form" color="main" @click="submitHandle">保存</c-button>
					<c-button size="form" @click="navigateBack()">取消</c-button>
				</template>
			</module-row>
		</module>
	</page>
</template>

<script>
	import quotaConfig from './components/config_quota.vue'
	import totalConfig from './components/config_total.vue'
	import chartsConfig from './components/config_charts.vue'
	import listConfig from './components/config_list.vue'
	import noticeConfig from './components/config_notice.vue'
	import timelineConfig from './components/config_timeline.vue'
	import galleryConfig from './components/config_gallery.vue'
	import {createStore} from '@deanwu/vue-component-library'
	import layoutTemplet from './components/layout_templet.js'

	const dimensionResolveQueue = {};
	const quotaResolveQueue = {};

	export default {
		components: {
			quotaConfig,
			totalConfig,
			chartsConfig,
			listConfig,
			noticeConfig,
			timelineConfig,
			galleryConfig
		},

		props: {
			id: String,
			copy: Boolean
		},

		data() {
			return {
				store: createStore({
					quotaDataSource: [],
					chartsDataSource: [],
					listDataSource: [],
					getDataSource: type => {
						if (this.store[`${type}DataSource`].length) return;
						this.request({
							url: '/digital/module/data/source',
							data: {
								module_type: {
									quota: 2,
									charts: 1,
									list: 3
								}[type]
							},
							success: data => {
								this.store.commit(`${type}DataSource`, data.map(item => {
									return {
										name: item.name,
										value: item.work_type_id
									}
								}));
							}
						})
					},

					dimensionData: {},
					getDimension: (module, dataType, source, resolve) => {
						if (!source || !dataType) return;
						let key = `${module}-${source}-${dataType}`;
						if (this.store.dimensionData[key]) {
							if (resolve) {
								resolve(this.store.dimensionData[key]);
							} else if (dimensionResolveQueue[key]) {
								dimensionResolveQueue[key].forEach(resolve => {
									resolve(this.store.dimensionData[key]);
								});
								delete dimensionResolveQueue[key];
							}
							return;
						}
						if (!dimensionResolveQueue[key]) {
							dimensionResolveQueue[key] = [];
							this.request({
								url: '/digital/module/data/dimensional',
								data: {
									module_type: module,
									work_type_id: source,
									data_type: dataType
								},
								success: data => {
									this.store.$set(this.store.dimensionData, key, data.map(item => {
										return {
											name: item.field_title,
											value: item.field_id,
											type: item.field_type == 1 || (item.field_type == 9 && item.config_json.type == 'text') ? 1 :
												item.field_type == 2 || (item.field_type == 9 && item.config_json.type == 'number') ? 2 :
												item.field_type == 3 || (item.field_type == 9 && item.config_json.type == 'time') ? 3 :
												item.field_type == 4 || (item.field_type == 9 && item.config_json.type == 'option') ? 4 : 0
										}
									}));
									this.store.getDimension.call(this, module, dataType, source);
								}
							})
						}
						dimensionResolveQueue[key].push(resolve);
					},

					quotaData: {},
					getQuota: (module, dataType, source, resolve) => {
						if (!source || !dataType) return;
						let key = `${module}-${source}-${dataType}`;
						if (this.store.quotaData[key]) {
							if (resolve) {
								resolve(this.store.quotaData[key]);
							} else if (quotaResolveQueue[key]) {
								quotaResolveQueue[key].forEach(resolve => {
									resolve(this.store.quotaData[key]);
								});
								delete quotaResolveQueue[key];
							}
							return;
						}
						if (!quotaResolveQueue[key]) {
							quotaResolveQueue[key] = [];
							this.request({
								url: '/digital/module/data/indicator',
								data: {
									module_type: module,
									work_type_id: source,
									data_type: dataType
								},
								success: data => {
									this.store.$set(this.store.quotaData, key, data.map(item => {
										return {
											name: item.field_title,
											value: item.field_id,
											type: item.field_type == 1 || (item.field_type == 9 && item.config_json.type == 'text') ? 1 :
												item.field_type == 2 || (item.field_type == 9 && item.config_json.type == 'number') ? 2 :
												item.field_type == 3 || (item.field_type == 9 && item.config_json.type == 'time') ? 3 :
												item.field_type == 4 || (item.field_type == 9 && item.config_json.type == 'option') ? 4 : 0
										}
									}));
									this.store.getQuota.call(this, module, dataType, source);
								}
							})
						}
						quotaResolveQueue[key].push(resolve);
					},

					quotaComputedOptions: (() => {
						let common = [{
							name: '计数',
							value: 'COUNT'
						}, {
							name: '去重后计数',
							value: 'DISTINCT_COUNT'
						}];
						let number = [{
							name: '求和',
							value: 'SUM'
						}, {
							name: '取平均值',
							value: 'AVG'
						}, {
							name: '取最小值',
							value: 'MIN'
						}, {
							name: '取最大值',
							value: 'MAX'
						}];

						return {
							0: common,
							1: common,
							2: common.concat(number),
							3: common,
							4: common
						}
					})(),

					refreshTimeOptions: [{
						name: '1分钟',
						value: 60
					}, {
						name: '5分钟',
						value: 300
					}, {
						name: '10分钟',
						value: 600
					}, {
						name: '30分钟',
						value: 1800
					}, {
						name: '1小时',
						value: 3600
					}]
				}),
				moduleName: {
					1: '图表区',
					2: '指标区',
					3: '报表区',
					4: '统计区',
					5: '通知公告',
					6: '时间轴',
					7: '照片墙'
				},
				layoutTemplet,
				layout: [],
				rightMenuTarget: {},

				currentModule: {},
				moduleConfig: {},

				sortModuleConfig: null
			}
		},

		computed: {
			rightMenu() {
				let add = [2, 4, 1, 3, 5, 6, 7];

				let list = [];
				list.push([{
					name: '切换为',
					submenu: add.filter(item => item != this.rightMenuTarget.type).map(item => {
						return {
							name: this.moduleName[item],
							handle: [item]
						}
					})
				}]);

				if (
					this.rightMenuTarget &&
					(
						(this.rightMenuTarget.row == 0 && this.layout[0].length < 3) ||
						(this.rightMenuTarget.row == 1 && this.layout[1] && this.layout[1].length < 2)
					)
				) {
					list.push([{
						name: '在左边添加',
						submenu: add.map(item => {
							return {
								name: this.moduleName[item],
								handle: ['left', item]
							}
						})
					}, {
						name: '在右边添加',
						submenu: add.map(item => {
							return {
								name: this.moduleName[item],
								handle: ['right', item]
							}
						})
					}]);
				}

				if (this.layout.length < 2) {
					let group = [{
						name: '在下方添加',
						submenu: add.map(item => {
							return {
								name: this.moduleName[item],
								handle: ['down', item]
							}
						})
					}]
					if (this.layout[0].length < 3) {
						group.unshift({
							name: '在上方添加',
							submenu: add.map(item => {
								return {
									name: this.moduleName[item],
									handle: ['up', item]
								}
							})
						});
					}
					list.push(group);
				}

				if (this.layout[0].length > 1 || this.layout[1]) {
					list.push([{
						name: '删除模块',
						color: 'red',
						handle: ['delete']
					}]);
				}

				return list;
			}
		},

		watch: {
			currentModule(val) {
				this.$nextTick(() => {
					this.$refs.config.setConfig(this.moduleConfig[val.module_id]);
				});
			}
		},

		mounted() {
			if (this.id != 'new') {
				this.request({
					url: '/digital/detail',
					data: {
						digital_id: this.id
					},
					loading: true,
					success: async data => {
						if (this.copy) {
							data.title += '-复制';
							data.name += '-复制';
						}
						this.$refs.form.set(data);
						this.layout = data.config_json;

						for (let i = 0; i < data.module_list.length; i++) {
							let item = data.module_list[i];
							if (item.module_type == 1) {
								this.moduleConfig[item.module_id] = {
									type: item.module_type,
									data: item.config_json.map(config => {
										return {
											hidden: config.hidden,
											name: config.title,
											source: config.work_type_id,
											type: config.data_type,
											dimensionOptions: [],
											dimension: config.dimensional.field_id,
											format: config.dimensional.data_format,
											quotaOptions: [],
											quota1: config.count_fields[0].field_id,
											quota2: config.count_fields[1] ? config.count_fields[1].field_id : '',
											computedOptions: [],
											computed1: config.count_fields[0].statistical_type,
											computed2: config.count_fields[1] ? config.count_fields[1].statistical_type : '',
											total: config.total,
											refresh: config.refresh_time || 300,
											filter: config.filter_condition
										}
									})
								}
							} else if (item.module_type == 2) {
								this.moduleConfig[item.module_id] = {
									type: item.module_type,
									data: item.config_json.map(config => {
										return {
											name: config.title,
											source: config.work_type_id,
											quotaOptions: [],
											quota: config.count_fields[0].field_id,
											computedOptions: [],
											computed: config.count_fields[0].statistical_type,
											color: config.color,
											filter: config.filter_condition
										}
									})
								}
							} else if (item.module_type == 3) {
								let config = item.config_json[0];
								this.moduleConfig[item.module_id] = {
									type: item.module_type,
									data: {
										name: config.title,
										source: config.work_type_id,
										field: await this.getTableFieldList(config.view_id),
										total: config.total,
										refresh: config.refresh_time || 300,
										autoScroll: config.auto_scroll || 1,
										autoSpan: config.auto_span || 0,
										filter: config.filter_condition,
										sort: config.sort_config
									}
								}
							} else if (item.module_type == 4) {
								let config = item.config_json[0];
								this.moduleConfig[item.module_id] = {
									type: item.module_type,
									data: {
										list: [config.main].concat(config.list).map(config => {
											return {
												name: config.title,
												source: config.work_type_id,
												quotaOptions: [],
												quota: config.count_fields[0].field_id,
												computedOptions: [],
												computed: config.count_fields[0].statistical_type,
												color: config.color,
												filter: config.filter_condition
											}
										}),
										background: config.background
									}
								}
							} else {
								this.moduleConfig[item.module_id] = {
									type: item.module_type,
									data: item.config_json[0]
								}
							}
						};
						this.$nextTick(() => {
							this.currentModule = this.layout[0][0];
						});
					}
				});
			} else {
				this.layout = layoutTemplet[0].value;
				this.$nextTick(() => {
					this.currentModule = this.layout[0][0];
				});
			}
		},

		methods: {
			getTableFieldList(id) {
				return new Promise(resolve => {
					this.request({
						url: '/sys_user_view/field_list',
						data: {
							view_id: id
						},
						success: data => {
							resolve(data.field_list);
						}
					});
				})
			},

			templetHandle(menu) {
				this.$confirm({
					message: '应用布局模板后已编辑的内容将会丢失，是否继续？',
					buttonName: '应用布局模板',
					resolve: () => {
						this.moduleConfig = {};
						this.layout = menu.value;
						this.currentModule = this.layout[0][0];
					}
				});
			},

			async rightMenuHandle(menu) {
				let module;
				switch (menu.handle[0]) {
				case 'left':
				case 'right':
					await this.saveModule();
					module = {
						module_id: this.newModuleId(),
						module_type: menu.handle[1]
					};
					this.layout[this.rightMenuTarget.row].splice(this.rightMenuTarget.col + (menu.handle[0] == 'right' ? 1 : 0), 0, module);
					this.currentModule = module;
					break;

				case 'up':
				case 'down':
					await this.saveModule();
					module = {
						module_id: this.newModuleId(),
						module_type: menu.handle[1]
					};
					this.layout[menu.handle[0] == 'up' ? 'unshift' : 'push']([module]);
					this.currentModule = module;
					break;

				case 'delete':
					if (this.layout[this.rightMenuTarget.row].length == 1) {
						this.layout.splice(this.rightMenuTarget.row, 1);
					} else {
						this.layout[this.rightMenuTarget.row].splice(this.rightMenuTarget.col, 1);
					}
					delete this.moduleConfig[this.rightMenuTarget.id];
					if (this.rightMenuTarget.id == this.currentModule.module_id) {
						this.currentModule = this.layout[0][0];
					}
					break;

				default:
					this.layout[this.rightMenuTarget.row][this.rightMenuTarget.col].module_type = menu.handle[0];
					delete this.moduleConfig[this.rightMenuTarget.id];
					this.$nextTick(() => {
						this.$refs.config.setConfig();
					});
					break;
				}
			},

			newModuleId() {
				let id = 1;
				while(this.layout.find(row => row.find(col => col.module_id == id))) {
					id++;
				};
				return id;
			},

			saveModule() {
				return new Promise(async resolve => {
					if (!this.$refs.config) {
						resolve();
						return;
					}
					let config = await this.$refs.config.getConfig();
					if (config) {
						this.moduleConfig[this.currentModule.module_id] = config;
						resolve();
					} else {
						this.$message({
							message: '请先完善当前模块的配置'
						});
					}
				})
			},

			async switchModule(item) {
				await this.saveModule();
				this.$refs.layout.warn(false);
				this.currentModule = item;
			},

			sortModule(row, col, item, e) {
				if (e.which != 1) return;
				this.sortModuleConfig = {
					row,
					col,
					module: null,
					target: null,
					position: {}
				}
				let dom = this.$refs[`${row}-${col}`][0];
				let domStart = {
					x: dom.offsetLeft,
					y: dom.offsetTop
				};
				this._sortTimer = setTimeout(() => {
					this.sortModuleConfig.module = item;
					this._sortMoveHandle(e);
				}, 200);
				this._sortMoveHandle = move => {
					if (!this.sortModuleConfig.module) return;
					this.sortModuleConfig.position = {
						'z-index': 1,
						'position': 'absolute',
						'left': domStart.x + move.clientX - e.clientX + 'px',
						'top': domStart.y + move.clientY - e.clientY + 'px',
						'width': dom.clientWidth + 'px',
						'height': dom.clientHeight + 'px',
						'opacity': '.3',
						'cursor': 'move',
						'pointer-events': 'none'
					}
				};
				this._sortEndHandle = () => {
					clearTimeout(this._sortTimer);
					this.sortModuleConfig = null;
					window.removeEventListener('mousemove', this._sortMoveHandle);
					window.removeEventListener('mouseup', this._sortEndHandle);
				};
				window.addEventListener('mousemove', this._sortMoveHandle);
				window.addEventListener('mouseup', this._sortEndHandle);
			},

			sortHandle(row, col, item, e) {
				if (this.sortModuleConfig && this.sortModuleConfig.module) {
					if (e.type == 'mouseenter') {
						this.sortModuleConfig.target = item;
					} else if (e.type == 'mouseleave') {
						this.sortModuleConfig.target = null;
					} else {
						this.layout[this.sortModuleConfig.row].splice(this.sortModuleConfig.col, 1, item);
						this.layout[row].splice(col, 1, this.sortModuleConfig.module);
					}
				}
			},

			async submitHandle() {
				await this.saveModule();
				this.$refs.form.submit({
					url: '/digital/edit',
					rule: {
						title: '请填写看板标题名称',
						layout: () => {
							if (this.layout.find(row => row.find(col => !this.moduleConfig[col.module_id]))) {
								return '请完善红色标签的模块配置';
							}
							return true;
						},
						name: '请填写菜单名称'
					},
					dataFormatter: data => {
						if (this.copy) {
							data.id = '';
						}
						data.config_json = this.layout;
						data.module_list = [];
						for (let id in this.moduleConfig) {
							let item = this.moduleConfig[id];
							if (item.type == 1) {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									config_json: item.data.map(item => {
										return {
											hidden: item.hidden,
											title: item.name,
											work_type_id: item.source,
											data_type: item.type,
											dimensional: {
												field_id: item.dimension,
												data_format: item.format
											},
											count_fields: [{
												field_id: item.quota1,
												statistical_type: item.computed1
											}].concat(item.type == 4 ? [{
												field_id: item.quota2,
												statistical_type: item.computed2
											}] : []),
											total: item.total,
											refresh_time: item.refresh,
											filter_condition: item.filter
										}
									})
								})
							} else if (item.type == 2) {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									config_json: item.data.map(item => {
										return {
											title: item.name,
											work_type_id: item.source,
											data_type: 5,
											count_fields: [{
												field_id: item.quota,
												statistical_type: item.computed
											}],
											color: item.color,
											filter_condition: item.filter
										}
									})
								})
							} else if (item.type == 3) {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									total: item.data.total,
									config_json: [{
										title: item.data.name,
										work_type_id: item.data.source,
										data_type: 6,
										total: item.data.total,
										refresh_time: item.data.refresh,
										filter_condition: item.data.filter,
										auto_scroll: item.data.autoScroll,
										auto_span: item.data.autoSpan,
										sort_config: item.data.sort,
										field_list: item.data.field
									}]
								})
							} else if (item.type == 4) {
								let config = item.data.list.map(item => {
									return {
										title: item.name,
										work_type_id: item.source,
										data_type: 5,
										count_fields: [{
											field_id: item.quota,
											statistical_type: item.computed
										}],
										color: item.color,
										filter_condition: item.filter
									}
								});
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									config_json: [{
										main: config[0],
										list: config.splice(1),
										background: item.data.background
									}]
								})
							} else {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									config_json: [item.data]
								})
							}
						}
						return data;
					},
					success: () => {
						this.$message({
							message: '保存成功'
						});
						this.$store.dispatch('updateLoginInfo');
						this.navigateBack();
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.layout {
		gap: 6px;
		position: relative;
		box-sizing: border-box;
		height: 200px;
		border: 1px solid var(--unit-border);
		padding: 6px;
		overflow: hidden;
		user-select: none;

		&-row {
			gap: 6px;
			width: 100%;

			&:nth-child(1) {
				flex-grow: 1.2;
			}
		}

		&-col {
			position: relative;
			height: 100%;
			border-radius: 6px;
			overflow: hidden;
			background: #071D4B;
			opacity: .6;
			cursor: pointer;

			&.z-crt {
				opacity: 1;
			}

			&.z-hl {
				outline: 2px solid var(--color-main);
				opacity: 1;
			}

			img {
				pointer-events: none;
			}

			span {
				position: absolute;
				right: 0;
				bottom: 0;
				padding: 0 6px;
				line-height: 25px;
				font-size: 13px;
				color: #fff;
				background: var(--color-main);

				^[-1].z-empty ^[-1..-1] {
					background: #f55;
				}
			}
		}
	}

	.module-config {
		min-height: 100%;
		
		&-box {
			margin: 10px 0;
			background: none;
		}
	}
</style>